export const messages = {
  lastName: {
    id: 'linkLogin.Label.LastName',
    defaultMessage: '-def-Last Name',
  },
  dateOfBirth: {
    id: 'linkLogin.Label.DateOfBirth',
    defaultMessage: '-def-Date of birth',
  },
  login: {
    label: {
      id: 'linkLogin.Form.Login.Label',
      defaultMessage: '-def-Log in',
    },
  },
};
